import { createFileRoute, Outlet } from "@tanstack/react-router"

import { Spinner } from "@/components/ui/spinner"
import { requireGuestBeforeLoad } from "@/lib/auth-guard"

export const Route = createFileRoute("/_public")({
  beforeLoad: async ({ context, location }) => {
    await requireGuestBeforeLoad({ context, location })
  },
  component: () => (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Outlet />
    </div>
  ),
  pendingComponent: () => (
    <div
      className="flex min-h-screen items-center justify-center"
      role="status"
    >
      <Spinner className="size-6" />
      <span className="sr-only">Checking authentication...</span>
    </div>
  ),
  pendingMs: 200,
  pendingMinMs: 300,
})
